import { jsx as i } from "react/jsx-runtime";
import g from "react";
import t, { css as e } from "styled-components";
import { I as p } from "./vendor_rango__assets.57b7cd48.js";
import { R as d } from "./index.cff5baaf.js";
const x = Object.keys(p), n = {
  SM: "SM",
  MD: "MD",
  LG: "LG"
};
Object.values(n);
const a = {
  Neutral: "neutral",
  Positive: "positive",
  Informative: "informative",
  Warning: "warning",
  Negative: "negative"
}, r = t(d).withConfig({
  displayName: "Icon",
  componentId: "sc-14x8k07-0"
})([""]), m = t.div.withConfig({
  displayName: "IconShapeContainer",
  componentId: "sc-14x8k07-1"
})(["display:flex;flex:0 0 auto;align-items:center;justify-content:center;border-radius:var(--border-radius-circular);", " ", " ", " ", " ", " ", " ", " ", ""], (o) => o.size === n.SM && e(["width:var(--size-6x);height:var(--size-6x);"]), (o) => o.size === n.MD && e(["width:var(--size-8x);height:var(--size-8x);"]), (o) => o.size === n.LG && e(["width:var(--size-10x);height:var(--size-10x);"]), (o) => o.type === a.Neutral && e(["background-color:var(--elements-bg-color-02);content:'", "';", "{color:var(--elements-icon-color);}"], r, r), (o) => o.type === a.Positive && e(["background-color:var(--positive-bg-color-01);", "{color:var(--on-positive-icon-color);}"], r), (o) => o.type === a.Informative && e(["background-color:var(--informative-bg-color-01);", "{color:var(--on-informative-icon-color);}"], r), (o) => o.type === a.Warning && e(["background-color:var(--warning-bg-color-01);", "{color:var(--on-warning-icon-color);}"], r), (o) => o.type === a.Negative && e(["background-color:var(--negative-bg-color-01);", "{color:var(--on-negative-icon-color);}"], r)), h = g.forwardRef(({
  size: o = n.MD,
  type: c = a.Neutral,
  icon: s,
  ...l
}, v) => /* @__PURE__ */ i(m, { size: o, type: c, ref: v, ...l, "data-testid": "rango-icon-shape", "data-rango-component": "rango-icon-shape", "data-is-rango": !0, children: /* @__PURE__ */ i(r, { icon: s, size: o }) }));
h.displayName = "RangoIconShape";
export {
  n as I,
  h as R,
  a,
  x as i
};
